import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

const Previewer = ({ blob }) => {
    const [previewUrl, setPreviewUrl] = useState('');

    useEffect(() => {
        const reader = new FileReader();
        reader.onload = () => {
            setPreviewUrl(reader.result);
        };

        if (blob) {
            reader.readAsDataURL(blob);
        }

        return () => {
            reader.abort();
        };
    }, [blob]);


    if (!blob) {
        return null; // or display a loading indicator
    }

    // Determine the type of blob and render accordingly
    const fileType = blob.type.split('/')[0];
    if (fileType === 'image') {
        return (
            <>
                <img src={previewUrl} alt="Preview" style={{ width: '100%' }} />
            </>
        );
    } else if (fileType === 'application' && blob.type === 'application/pdf') {
        return (
            <>
                <embed src={previewUrl} type="application/pdf" width="100%" height="600px" />
            </>
        );
    } else {
        return <p>This file type is not supported for preview.</p>;
    }
};



Previewer.propTypes = {
    blob: PropTypes.object,
}

export default Previewer;
